<template>
  <v-dialog
    v-model="dialog"
    scrollable
    :max-width="exportData ? '750px' : '350px'"
  >
    <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" style="cursor: pointer;">
            <v-icon style="cursor:pointer;">
                mdi-export-variant
            </v-icon>
            <span>Export Integration</span>
        </div>
    </template>
    <v-card v-if="exportData">
      <v-card-title>Export Data</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <textarea class="w-100" rows="10" readonly>{{ exportReadable }}</textarea>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="primary darken-1"
          text
          @click="dialog = false; exportData = null;"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title>Select Table to Export</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 300px;">

        <v-checkbox
          v-for="exportOption in allExportOptions"
          :key="exportOption.value"
          v-model="exports"
          :label="exportOption.label"
          :value="exportOption.value"
          dense
        ></v-checkbox>

        <v-checkbox
          v-model="selectAll"
          label="Select All"
          dense
          @change="toggleAllCheckboxes"
        ></v-checkbox>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="primary darken-1"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="primary darken-1"
          :disabled="exporting || isEmptyExport"
          text
          @click="onExport"
        >
          <span v-if="exporting">
            <v-progress-circular indeterminate size="12" width="2"></v-progress-circular>
            Exporting
          </span>
          <span v-else>
            Export
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from '@/js/event-bus.js';

export default {
  props: {
    id: { default: 0, type: Number },
  },
  data() {
    return {
      dialog: false,
      exports: ['integrations'],
      exporting: false,
      exportData: null,
      selectAll: false,
    };
  },

  computed: {
    exportReadable() {
      if (!this.exportData) {
        return '';
      }

      return this.exportData.join('\n\n');
    },

    isEmptyExport() {
      return !this.exports || this.exports.length <= 0;
    },

    allExportOptions() {
      return [
        { label: 'Integrations', value: 'integrations' },
        { label: 'Integrations keys', value: 'integration_keys' },
        { label: 'Integration metas', value: 'integration_meta' },
        { label: 'Field mappers', value: 'field_mapper' },
        { label: 'Filters', value: 'integration_source_filters' },
        { label: 'Value lookups', value: 'value_lookups' },
        { label: 'Packing Rules', value: 'packing_rules' },
        { label: 'Live Rates Carrier Groupings & Services', value: 'liverates' },
        { label: 'Status mappers', value: 'machship_status_mapping' },
        { label: 'Accounts', value: 'accounts' },
        { label: 'Users', value: 'users' },
      ];
    },
  },

  methods: {
    toggleAllCheckboxes() {
      this.exports = this.selectAll ? this.allExportOptions.map(option => option.value) : [];
    },

    onExport() {
      if (this.exporting) {
        return;
      }

      this.exporting = true;

      this.$http
        .post('/api/integrations/export/' + this.id, { exports: this.exports })
        .then(({ data }) => {
          this.exporting = false;
          this.exportData = data.data;
        })
        .catch(err => {
          EventBus.$emit('show-error', err);
          this.exporting = false;
        });
    },
  },
};
</script>
